var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 4V14.32",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 14.32V4",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4986 25.7682L20.5093 27.8762C21.2906 28.2868 22.2026 27.6228 22.0533 26.7535L21.2866 22.2882L24.532 19.1268C25.164 18.5108 24.816 17.4375 23.9426 17.3108L19.4586 16.6588L17.4533 12.5935C17.0626 11.8015 15.9346 11.8015 15.544 12.5935L13.54 16.6588L9.05596 17.3108C8.18262 17.4375 7.83462 18.5108 8.46662 19.1268L11.712 22.2882L10.9453 26.7535C10.796 27.6228 11.708 28.2855 12.4893 27.8762L16.5 25.7682",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.916 15.896L8.50663 12.7947C7.67863 12.32 7.16663 11.4373 7.16663 10.4813V6.66667C7.16663 5.19333 8.35996 4 9.83329 4H23.1666C24.64 4 25.8333 5.19333 25.8333 6.66667V10.4813C25.8333 11.4373 25.3226 12.32 24.4933 12.7947L19.084 15.896",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.9f1e3c18f6ddf98a2804915688806419.svg";
export { ForwardRef as ReactComponent };